import React, { useState } from 'react';
import { LogIn } from 'lucide-react';
import AuthModal from './AuthModal';
import '../pages/sportsbook-betby.css';

// Spor sayfası misafire kapalıyken çizilen kart.
//
// Panelden "giriş yapmadan görüntüleme" kapatıldığında hem hazır spor kitabı
// (Betby/Flexrix) hem de sitenin kendi sportsbook'u ziyaretçiye bunu gösterir;
// iki ekran ayrı yazılsaydı biri "giriş yapın" derken diğeri boş sayfa
// çizerdi. Başka bir sayfaya yönlendirmek de denenmedi: kaybolan bir bölüm
// oyuncuya "site bozuldu" gibi görünüyor (bkz. AccessBlockedNotice).
const SportsLoginGate = () => {
  const [authOpen, setAuthOpen] = useState(false);
  return (
    <div className="betby-shell betby-shell--message">
      <div className="betby-card">
        <LogIn size={28} className="betby-card-icon" />
        <h1>Spor bahisleri için giriş yapın</h1>
        <p>
          Oranları görüntülemek, kupon oluşturmak ve canlı bahis yapmak için
          hesabınıza giriş yapmanız gerekir.
        </p>
        <button
          type="button"
          className="betby-btn"
          onClick={() => setAuthOpen(true)}
        >
          Giriş Yap
        </button>
      </div>
      <AuthModal
        open={authOpen}
        onClose={() => setAuthOpen(false)}
        defaultTab="login"
      />
    </div>
  );
};

export default SportsLoginGate;
